<div class="phone-input">
  <!-- Country code (entered manually, e.g. +44) -->
  <mat-form-field appearance="outline" class="country-code-field">
    <mat-label>Country code</mat-label>
    <input
      matInput
      type="tel"
      placeholder="+44"
      aria-label="Country code"
      [(ngModel)]="countryCode"
      [ngModelOptions]="{ standalone: true }"
      [disabled]="disabled"
      (ngModelChange)="onFieldChange()"
      (blur)="onBlur()" />
  </mat-form-field>

  <!-- National phone number -->
  <mat-form-field appearance="outline" class="phone-field">
    <mat-label>{{ label }}</mat-label>
    <mat-icon matPrefix>phone</mat-icon>
    <input
      matInput
      type="tel"
      [placeholder]="example || '7123456789'"
      aria-label="Phone number"
      [(ngModel)]="nationalNumber"
      [ngModelOptions]="{ standalone: true }"
      [disabled]="disabled"
      (ngModelChange)="onFieldChange()"
      (blur)="onBlur()" />
    <mat-hint *ngIf="example">Example for {{ countryCode }}: {{ example }}</mat-hint>
  </mat-form-field>
</div>

<p class="phone-incomplete-error" *ngIf="showIncompleteError">
  Enter the country code for this number.
</p>
